import PropTypes from 'prop-types'
import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import Select from '../../../../components/forms/Select'
import { setModal } from '../../../../utils/FormUtils'
import Job from '../../../dto/DtoJob'
import ImportFileModal from './ImportFileModal'
import MultiContributorsAutocomplete from '../../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import ContributorAction from '../../../../referencial/components/contributor/actions/ContributorAction'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import { connect } from 'react-redux'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import CampaignDto from '../../../../campaign/dto/CampaignDto'
import IntegrationModeDialog from '../IntegrationModeDialog'

class ImportQesoutPanel extends Component {
    constructor(props) {
        super(props)
        const parameters = props.job.parameters.parameters
        this.state = {
            directory: undefined,
            filter: undefined,
            type: undefined,
            rename: false,
            ...(parameters.length ? JSON.parse(parameters[0]) : {}),
        }
    }
    componentDidMount = () => {
        this.props.fetchQualityCampaigns()
    }

    componentDidMount = () => {
        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
    }

    setAdvancedFtpModal =() => {
        setModal({
            title: i18n.importParam,
            content: <ImportFileModal url={this.state.directory} onChange={name => this.setState({ filter: name }) } />,
        })
    }

    getFilters = () => {
        return this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    onChangeParameter = obj => {
        const newParameter = {
            ...this.state,
            ...obj,
        }
        this.setState(newParameter)
        this.props.handleChangeParameters([JSON.stringify(newParameter)])
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type)) || ''
        }
        return ''
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('DATA'))
            if (integration) {
                return [...data, integration]
            }
            return data
        })()
        this.props.onChangeDataTypes(newDataTypes)
    }

    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('station'))
            if (integration) {
                return [...data, 'stationIntegration']
            }
            return data
        })()
        this.props.onChangeDataTypes(newDataTypes)
    }

    render() {
        const disabled = { disabled: !this.props.isEditMode }
        const filters= this.getFilters()
        const dataTypes = [
            {
                id: 'QUALITY',
                label: i18n.quality,
            },
            {
                id: 'QUANTITY',
                label: i18n.quantity,
            },
        ]

        return (
            <div>
                <div className='row no-margin valign-wrapper'>
                    <Select
                        value={this.props.type}
                        options={dataTypes}
                        label={i18n.typeSettings}
                        col={4}
                        nullLabel='&nbsp;'
                        onChange={v => this.onChangeParameter({ type: v })}
                        disabled={ true }
                    />
                    <Select
                        value={this.getDataTypes('DATA')}
                        options={getIntegrationModes()}
                        label={ i18n.dataIntegration }
                        labelSpan={ <IntegrationModeDialog /> }
                        col={4}
                        obligatory
                        onChange={this.handleChangeDataIntegration}
                        {...disabled}
                    />
                    <MultiContributorsAutocomplete
                        col={4}
                        multiple
                        options={this.props.contributors}
                        values={filters.excludedProducer}
                        label={i18n.producersExcluded}
                        onChange={values => {
                            this.onChangeFilters({ excludedProducers: values })
                        }}
                        {...disabled}
                    />
                    <Select
                        value={this.state.campaignId}
                        keyValue='id'
                        col={4}
                        options={this.props.qualityCampaigns.filter(cs => cs.campaignType === 3)}
                        label={i18n.campaign}
                        onChange={v => this.onChangeParameter({ campaignId: v })}
                        {...disabled}
                    />
                </div>
                <div className='row no-margin valign-wrapper'>
                    <div className='col s4'>
                        <Checkbox
                            checked={!!this.getDataTypes('station')}
                            label={i18n.integrateStationInfo}
                            onChange={this.handleChangeStationIntegration}
                            {...disabled}
                        />
                    </div>
                    <div className='col s4'>
                        <Checkbox
                            checked={this.state.rename}
                            label={i18n.fileRenaming}
                            onChange={v => this.onChangeParameter({ rename: v })}
                            {...disabled}
                        />
                    </div>
                    <div className='col s4'>
                        <Checkbox
                            checked={this.state.validation}
                            label={i18n.formatValidationxsd}
                            onChange={v => this.onChangeParameter({ validation: v })}
                            {...disabled}
                        />
                    </div>
                </div>
                <div className='row no-margin valign-wrapper'>
                    <div className=' input-field col s3'>
                        <label>{i18n.defineDirectory}</label>
                    </div>
                    <div className='input-field col s9'>
                        <input
                            id='txtDirDef'
                            type='text'
                            value={this.state.directory}
                            onChange={e => this.props.isEditMode && this.onChangeParameter({ directory: e.target.value })}
                            placeholder={i18n.selectDirectory}
                        />
                        <a className='btn btn-small secondary-color-back' onClick={ () => this.setAdvancedFtpModal()} ><span title={ i18n.importLabelFtp }> <i className='material-icons'>input </i> </span></a>
                    </div>
                </div>
                <div className='row no-margin valign-wrapper'>
                    <div className='input-field col s3'>
                        <label>{i18n.filter}</label>
                    </div>
                    <div className='input-field col s9'>
                        <input
                            id='txtFilter'
                            type='text'
                            value={this.state.filter}
                            onChange={e => this.props.isEditMode && this.onChangeParameter({ filter: e.target.value })}
                            placeholder={i18n.filterExample}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

ImportQesoutPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    isEditMode: PropTypes.bool,
    handleChangeParameters: PropTypes.func.isRequired,
    onChangeDataTypes: PropTypes.func.isRequired,
    measureOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    })),
    type: PropTypes.string.isREquired,
    fetchContributors: PropTypes.func,
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    onChangeJob: PropTypes.func,
    qualityCampaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
    fetchQualityCampaigns: PropTypes.func,
}

const mapStateToProps = store => ({
    contributors: store.ContributorReducer.contributors,
    qualityCampaigns: store.QualityReducer.qualityCampaigns,
})

const mapDispatchToProps = {
    fetchContributors: ContributorAction.fetchContributors,
    fetchQualityCampaigns: CampaignAction.fetchQualityCampaigns,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportQesoutPanel)
